export default __webpack_public_path__ + "static/Unassembled_Mek-d20d63919cc2b8ee18bfc9ce6fd253e8.png";